import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import Productlist from "../../component/ProductList/ProductList";
import ProductFilter from "component/ProductFilter/ProductFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  saveDeatailInternationalHeader,
  saveInternationalHeader,
  saveProductListing,
  setFooterShow,
} from "features/homepage/homeDataSlice";
import { apiHandler } from "api";
import { endpoint } from "api/endpoint";
import Pagination from "component/Pagination/Pagination";
import styled, { css } from "styled-components";
import { Button, Offcanvas } from "react-bootstrap";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import Breadcrew from "component/Breadcrumb/BreadCrumb";
import { toast } from "react-toastify";
import { ImCross } from "react-icons/im";
import COLOR_CODES from "asset/json/colorcodes.json";
import "./Style.css";
import BannerPlaceholder from "../../asset/image/Default_ProductListing_Banner.jpg";
import ErrorPage from "container/errorPage/ErrorPage";
import * as DOMPurify from "dompurify";

const Maindiv = styled.div`
  z-index: 100;
  display: flex;
  align-items: center;

  ${(props) =>
    props.fixed &&
    css`
      position: fixed;
      background: none;
      top: 50px;
    `}
`;

const ProductListing = (props) => {
  const [loader, setLoader] = useState(false);
  const [leftMenuState, setLeftMenuState] = useState("");
  const leftAboutMenu = useRef();
  const rightContent = useRef();
  const [filteredProducts, setFiteredProducts] = useState(null);
  const [recordPerPage, setRecordPerPage] = useState("12");
  const [selectedPageIndex, SetSelectedPageIndex] = useState(1);
  const { internationalheader } = useSelector((state) => state.home);
  const [sortFilterOptions, setSortFilterOptions] = useState({});
  const [showicon, setShowIcon] = useState(false);
  const [showiconTwo, setShowIconTwo] = useState(false);
  const { categories, productFilter, selectedCategory, selectedType } =
    useSelector((state) => state.home);
  const [listing, setListing] = useState(false);
  const [productList, setProductList] = useState([]);
  const [filters, setFilters] = useState([]);
  const [fiterOption, setFilterOption] = useState({});
  const [sortOptions, setSortOptions] = useState([]);
  const [sortOption, setSortOption] = useState("");
  const [productName, setProductName] = useState("");
  const [productUrlkey, setProductUrlkey] = useState("");
  const [category, setCategory] = useState({});
  const [catDesp, setCatDesp] = useState("");
  const controlContainer = useRef();
  const [hideFilter, setHideFilter] = useState({});
  const [breadurl, setBreadUrl] = useState("");
  const [germFreeflag, setGermFreeFlag] = useState(false);
  const [internationalflag, setInternationalFlag] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const { pathname } = useLocation();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [action, setAction] = useState(false);
  const [hide, setHide] = useState(true);
  const histroy = useHistory();

  useEffect(() => {
    if (error) {
      setError(false);
    }
  }, [location]);

  useEffect(() => {
    if (location && location.pathname.includes("/products/germ-free/")) {
      setGermFreeFlag(true);
      setInternationalFlag(false);
    } else if (
      location &&
      location.pathname.includes("/products/johnson-international/")
    ) {
      setInternationalFlag(true);
      setGermFreeFlag(false);
    } else {
      setGermFreeFlag(false);
      setInternationalFlag(false);
    }
  }, [location]);
  useEffect(() => {
    if (
      (location && location.pathname.includes("/products/ji-ranges")) ||
      (location &&
        location.pathname.includes("/products/johnson-international"))
    ) {
      dispatch(saveInternationalHeader(false));
    } else {
      dispatch(saveInternationalHeader(true));
      dispatch(saveDeatailInternationalHeader(false));
    }
  }, [location]);

  useEffect(() => {
    if (internationalheader === false) {
      setBreadUrl("/international");
    } else if (location && location.pathname.includes("/products/ji-ranges")) {
      setBreadUrl("/international");
    } else {
      setBreadUrl("/");
    }
  }, [internationalheader]);

  useEffect(() => {
    setAction(false);
    setHide(true);
  }, [pathname]);

  useEffect(() => {
    const textNodes = document.getElementById("contentid");
    if (textNodes && textNodes.scrollHeight > textNodes.clientHeight) {
      setHide(false);
    }
  }, [category.description]);

  const getPageData = (event) => {
    let pageIndex = 0;
    let pageCount = Math.ceil(productList.length / recordPerPage);
    switch (event.target.innerText) {
      case "FIRST":
        pageIndex = 1;
        break;
      case "<":
        pageIndex = selectedPageIndex - 1;
        break;
      case "LAST":
        pageIndex = pageCount;
        break;
      case ">":
        pageIndex = selectedPageIndex + 1;
        break;
      default:
        pageIndex = parseInt(event.target.innerText);
        break;
    }
    if (pageIndex < 1) pageIndex = 1;
    else if (pageIndex > pageCount) pageIndex = pageCount;

    let selectedList = productList.slice(
      (pageIndex - 1) * recordPerPage,
      pageIndex * recordPerPage
    );
    SetSelectedPageIndex(pageIndex);
    setFiteredProducts(selectedList);
  };

  const getPageDetails = () => {
    let DataCount = Math.ceil(productList.length / recordPerPage);
    let pageArray = [];
    Array.from(new Array(DataCount)).forEach((count, index) => {
      if (index + 1 === selectedPageIndex) {
        pageArray.push({
          text: `${index + 1}`,
          active: true,
        });
      } else {
        pageArray.push({
          text: `${index + 1}`,
        });
      }
    });
    return pageArray;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (rightContent.current && leftAboutMenu.current) {
        const changeMenu = rightContent.current.getBoundingClientRect();
        const initialMenu = leftAboutMenu.current.getBoundingClientRect();
        // console.log(window.scrollY, initialMenu, changeMenu.top);
        // console.log(changeMenu.top);
        if (changeMenu.top < 0) {
          const newPos = changeMenu.top + changeMenu.height;
          if (newPos < initialMenu.height) setLeftMenuState("bottom");
          else setLeftMenuState("fixed");
        } else setLeftMenuState("");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setLoader(true);
    let producturl = params.category || props.category;
    let typeId = params.type || props.type;
    let productCategory =
      categories &&
      categories.children_data &&
      categories.children_data.filter((p) => p.url_key === producturl);
    let id = -1;
    console.log("productCategory", productCategory)
    setFilterOption({});
    if (productCategory && productCategory.length > 0) {
      if (selectedCategory === 0) {
        setProductUrlkey(productCategory[0].url_key);
      }
      setProductName(productCategory[0].name);
      let productList =
        productCategory[0].children_data &&
        productCategory[0].children_data.filter((p) => p.url_key === typeId);
      if (productList && productList.length > 0) {
        setCategory(productList[0]);
        setCatDesp(productList[0] ? productList[0].description : "");
        document.title = productList[0].meta_title;
        id = productList[0].id;
      } else {
        setError(true);
        setCategory(productCategory[0]);
        id = productCategory[0].id;
      }
    } 
    
    // else {
    //   console.log("product listing error page rendered");
    //   debugger;
    //   histroy.push("/error-404");
    // }
    if (id !== -1) getProuctListing(id, {}, { name: "asc" });
  }, [
    selectedCategory,
    selectedType,
    categories,
    params.category,
    params.type,
    props.category,
    props.type,
  ]);

  useEffect(() => {
    let filter = [];
    let list = [];
    let options = [];
    productFilter &&
      productFilter.forEach((pf) => {
        if (pf.filters) {
          pf.filters &&
            pf.filters.forEach((f) => {
              if (f.name === "Color") {
                let colValues =
                  f.values &&
                  f.values.map((v) => {
                    const colorCodeLabels =
                      COLOR_CODES &&
                      COLOR_CODES.filter((codes) => codes.code === v.label);

                    return {
                      ...v,
                      label:
                        colorCodeLabels && colorCodeLabels[0]
                          ? colorCodeLabels[0].Colour
                          : v.label,
                    };
                  });
                filter.push({ ...f, values: colValues });
              } else {
                filter.push(f);
              }
            });
        }
        if (pf.products) {
          list = pf.products;
          if (pf.products.length > 12) {
            setListing(true);
          } else {
            setListing(false);
          }
        }
        if (pf.sort_option) {
          options = pf.sort_option;
        }
      });
    setFilters(filter);
    setProductList(list);
    const slicedProds = list.slice(0, recordPerPage);
    setFiteredProducts(slicedProds);
    setSortOptions(options);
  }, [productFilter, recordPerPage]);

  useEffect(() => {
    window.scrollTo(0, findPosition(document.getElementById("view_first")));
  }, [pathname]);
  const showHideFilter = (index) => {
    if (hideFilter[index]) {
      let hf = { ...hideFilter };
      delete hf[index];
      setHideFilter({ ...hf });
    } else {
      setHideFilter({ ...hideFilter, [index]: true });
    }
  };

  const getProuctListing = async (id, filter, sortby) => {
    setLoader(true);
    const data = {
      categoryId: id,
      filter: filter,
      sortby: sortby,
    };
    const result = await apiHandler({
      url: endpoint.PRODUCT_LISTING,
      method: "POST",
      data: data,
    });
    if (result.data.message) {
      toast.error(result.data.message);
      return;
    }
    dispatch(saveProductListing(result.data));
    setLoader(false);
  };
  const changeSortingOrder = (event) => {
    setSortOption(event.target.value);
    getProuctListing(category.id, sortFilterOptions, {
      [event.target.value]: "asc",
    });
  };
  const onFilterChange = (code, value) => {
    setFilterOption({ ...fiterOption, [code]: value });
    let newFilterOption = {};
    Object.keys(fiterOption).forEach((k) => {
      newFilterOption[k] = fiterOption[k].value;
    });
    setSortFilterOptions({ ...newFilterOption, [code]: value.value });
    getProuctListing(
      category.id,
      { ...newFilterOption, [code]: value.value },
      sortOption === ""
        ? { name: "asc" }
        : {
            [sortOption]: "asc",
          }
    );
  };

  const onRemoveFilter = async (code) => {
    const newData = { ...fiterOption };
    delete newData[code];
    await setFilterOption((prevData) => {
      const newData = { ...prevData };
      delete newData[code];
      return newData;
    });
    let newFilterOption = {};
    Object.keys(newData).forEach((k) => {
      newFilterOption[k] = newData[k].value;
    });
    if (sortOption !== "") {
      getProuctListing(category.id, newFilterOption, { [sortOption]: "asc" });
    } else {
      getProuctListing(category.id, newFilterOption, { name: "asc" });
    }
  };

  const onRemoveAll = () => {
    setFilterOption({});
    let newFilterOption = {};
    if (sortOption !== "") {
      getProuctListing(category.id, newFilterOption, { [sortOption]: "asc" });
    } else {
      getProuctListing(category.id, newFilterOption, { name: "asc" });
    }
  };

  const handleicons = () => {
    setShowIcon(!showicon);
  };

  const handleBlurelist = () => {
    setShowIcon(false);
  };

  const handleiconstwo = () => {
    setShowIconTwo(!showiconTwo);
  };

  const handleiconblurecount = () => {
    setShowIconTwo(false);
  };

  const handleRecordCount = (e) => {
    setRecordPerPage(e.target.value);
  };

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const getBreadCrumbData = () => {
    let list = [];
    list.push({ name: "Home", url: breadurl });
    list.push({
      name: productName || "",
      url:
        "/products/" +
        (selectedCategory === 0 ? productUrlkey : selectedCategory),
    });
    list.push({ name: category.name || "", url: null });
    return list;
  };

  const getLeftFilterStyle = () => {
    return leftMenuState === "fixed"
      ? {
          left: "auto",
          top: 80,
          position: "fixed",
        }
      : leftMenuState === "bottom"
      ? {
          position: "absolute",
          bottom: 10,
        }
      : {};
  };

  const findPosition = (obj) => {
    var currenttop = 0;
    if (obj.offsetParent) {
      do {
        currenttop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [currenttop];
    }
  };

  const handleradioblur = () => {
    console.log("BLUR RADIO");
    document.getElementById("radio-blur-moblie").blur();
  };

  const doit = () => {
    setAction(!action);
  };

  useEffect(() => {
    if (error) {
      dispatch(setFooterShow(true));
    } else {
      dispatch(setFooterShow(false));
    }

    return () => {
      dispatch(setFooterShow(false));
    };
  }, [error, pathname]);

  console.log("error", error);
  return (
    <>
      {!error ? (
        <span ref={controlContainer} className="page-wrapper">
          <div id={"view_first"} className="banner">
            <img
              src={category.banner_image_url || BannerPlaceholder}
              alt=""
              width={1920}
              height={450}
              fetchpriority="high"
            />
            <Breadcrew data={getBreadCrumbData()} />
          </div>
          <section>
            <div className="container">
              <div className="row ">
                <div className="col-lg-9 main-content categorylisting">
                  <section className="listingpage">
                    <div className="container">
                      <div className="main-heading  text-left pb-3">
                        {category && category.name ? (
                          <h1>{category.name}</h1>
                        ) : (
                          <h1
                            className="card-text placeholder-glow"
                            style={{ marginBottom: 0 }}
                          >
                            <span
                              className="placeholder"
                              style={{ width: "20%" }}
                            ></span>
                          </h1>
                        )}
                        {/* updated */}
                        {!!filteredProducts ? (
                          <>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(catDesp),
                              }}
                              // className={action ? "" : "showMoreContent"}
                              id="contentid"
                            ></p>
                            {/* <span
                              className={hide ? "hide" : "read_more"}
                              id={action ? "more1" : "less1"}
                              onClick={doit}
                            >
                              Read more...
                            </span>
                            <span
                              className={hide ? "hide" : "read_less"}
                              id={action ? "less1" : "more1"}
                              onClick={doit}
                            >
                              Read Less
                            </span>{" "} */}
                          </>
                        ) : (
                          <div>
                            <p
                              className="card-text placeholder-glow"
                              style={{ marginBottom: 0 }}
                            >
                              <span
                                className="placeholder"
                                style={{ width: "100%" }}
                              ></span>
                            </p>
                            <p
                              className="card-text placeholder-glow"
                              style={{ marginTop: 0, marginBottom: "15px" }}
                            >
                              <span
                                className="placeholder"
                                style={{ width: "75%" }}
                              ></span>
                            </p>
                          </div>
                        )}
                        {/* updated */}
                      </div>
                    </div>
                  </section>
                  <nav
                    className="toolbox sticky-header"
                    data-sticky-options="{'mobile': true}"
                  >
                    <div className="toolbox-left">
                      <a className="sidebar-toggle">
                        <svg
                          data-name="Layer 3"
                          id="Layer_3"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <line
                            x1="15"
                            x2="26"
                            y1="9"
                            y2="9"
                            className="cls-1"
                          ></line>
                          <line
                            x1="6"
                            x2="9"
                            y1="9"
                            y2="9"
                            className="cls-1"
                          ></line>
                          <line
                            x1="23"
                            x2="26"
                            y1="16"
                            y2="16"
                            className="cls-1"
                          ></line>
                          <line
                            x1="6"
                            x2="17"
                            y1="16"
                            y2="16"
                            className="cls-1"
                          ></line>
                          <line
                            x1="17"
                            x2="26"
                            y1="23"
                            y2="23"
                            className="cls-1"
                          ></line>
                          <line
                            x1="6"
                            x2="11"
                            y1="23"
                            y2="23"
                            className="cls-1"
                          ></line>
                          <path
                            d="M14.5,8.92A2.6,2.6,0,0,1,12,11.5,2.6,2.6,0,0,1,9.5,8.92a2.5,2.5,0,0,1,5,0Z"
                            className="cls-2"
                          ></path>
                          <path
                            d="M22.5,15.92a2.5,2.5,0,1,1-5,0,2.5,2.5,0,0,1,5,0Z"
                            className="cls-2"
                          ></path>
                          <path
                            d="M21,16a1,1,0,1,1-2,0,1,1,0,0,1,2,0Z"
                            className="cls-3"
                          ></path>
                          <path
                            d="M16.5,22.92A2.6,2.6,0,0,1,14,25.5a2.6,2.6,0,0,1-2.5-2.58,2.5,2.5,0,0,1,5,0Z"
                            className="cls-2"
                          ></path>
                        </svg>{" "}
                        <span>
                          <Button
                            onClick={handleShow}
                            className="mobile-menu-toggler"
                            type="button"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            Filter
                          </Button>
                          <Offcanvas
                            scroll={true}
                            style={{ width: "70%" }}
                            show={show}
                            onHide={handleClose}
                          >
                            <Offcanvas.Header
                              style={{ background: "#f5f5f5" }}
                              closeButton
                            >
                              <Offcanvas.Title>Filter</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body
                              style={{
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                background: "#f5f5f5",
                              }}
                            >
                              {/* <ProductFilter
                          filter={filters}
                          onChange={onFilterChange}
                        /> */}
                              <div className="container">
                                <div className="row">
                                  <div
                                    className="sidebar-wrapper mt-12"
                                    style={{
                                      borderBottom:
                                        "0px none rgb(119, 119, 119)",
                                      width: "25rem",
                                    }}
                                  >
                                    <div className="widget">
                                      <div className="fiter-clear-all">
                                        {Object.keys(fiterOption).length >
                                          0 && (
                                          <h3 className="widget-title">
                                            Filter By
                                          </h3>
                                        )}
                                        {Object.keys(fiterOption).length >
                                          0 && (
                                          <button
                                            className="Clear-all"
                                            onClick={() => {
                                              setHideFilter({});
                                              onRemoveAll();
                                            }}
                                          >
                                            Clear All
                                          </button>
                                        )}
                                      </div>

                                      {Object.keys(fiterOption).map(
                                        (k, index) => (
                                          <div
                                            key={index}
                                            className="flexcrossdiv"
                                          >
                                            <br />
                                            <button
                                              onClick={() => {
                                                onRemoveFilter(k);
                                                setHideFilter({});
                                              }}
                                              className="flexcrossbtn"
                                            >
                                              <ImCross className="iconfiltercross" />{" "}
                                              <span className="boldheadingselected">
                                                {fiterOption[k].name + ": "}
                                              </span>{" "}
                                              <span
                                                dangerouslySetInnerHTML={{
                                                  __html: DOMPurify.sanitize(
                                                    fiterOption[k].label
                                                  ),
                                                }}
                                              ></span>
                                            </button>
                                          </div>
                                        )
                                      )}
                                    </div>
                                    {filters.map((item, index) => (
                                      <>
                                        {item.code !== "price" && (
                                          <div key={index} className="widget">
                                            <h3 className="widget-title">
                                              <a
                                                data-toggle="collapse"
                                                role="button"
                                                aria-expanded="true"
                                                aria-controls="widget-body"
                                                className={
                                                  hideFilter[index]
                                                    ? "collapsed"
                                                    : ""
                                                }
                                                onClick={() =>
                                                  showHideFilter(index)
                                                }
                                              >
                                                {item.name}
                                              </a>
                                            </h3>

                                            <div
                                              className={
                                                hideFilter[index]
                                                  ? "collapse"
                                                  : "collapse show"
                                              }
                                              id={"widget-body-" + index}
                                            >
                                              <div className="widget-body custom-control custom-radio">
                                                {item.values &&
                                                  item.values.map((raw, i) => (
                                                    <ul
                                                      key={i}
                                                      className="cat-list"
                                                    >
                                                      <li
                                                        onClick={() => {
                                                          onFilterChange(
                                                            item.code,
                                                            {
                                                              name: item.name,
                                                              value: raw.value,
                                                              label: raw.label,
                                                            }
                                                          );
                                                          handleradioblur();
                                                          setHideFilter({});
                                                        }}
                                                      >
                                                        <a>
                                                          <input
                                                            type="radio"
                                                            name="radio"
                                                            id="radio-blur-moblie"
                                                            checked={false}
                                                            className="padding-right-filter"
                                                            onClick={(e) =>
                                                              handleradioblur(e)
                                                            }
                                                          />
                                                          <span
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                DOMPurify.sanitize(
                                                                  raw.label
                                                                ),
                                                            }}
                                                          ></span>
                                                        </a>
                                                      </li>
                                                    </ul>
                                                  ))}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </Offcanvas.Body>
                          </Offcanvas>
                        </span>
                      </a>

                      <div className="toolbox-item toolbox-sort">
                        <label>Sort By:</label>
                        <div className="select-custom ">
                          {showicon ? (
                            <RiArrowDropUpLine className="arrow-custom-after" />
                          ) : (
                            <RiArrowDropDownLine className="arrow-custom-after" />
                          )}

                          <select
                            name="orderby"
                            className="form-control"
                            onClick={() => handleicons()}
                            defaultValue={"menu_order"}
                            onChange={(event) => changeSortingOrder(event)}
                            onBlur={(e) => handleBlurelist(e)}
                          >
                            {/* <option
                        onClick={() => getBreadCrumbData()}
                        value='menu_order'
                      >
                        Default sorting
                      </option> */}
                            {sortOptions &&
                              sortOptions.map((opt, i) => (
                                <>
                                  {opt.code !== "price" && (
                                    <option key={i} value={opt.code}>
                                      {opt.label}
                                    </option>
                                  )}
                                </>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="toolbox-right">
                      {listing && (
                        <div className="toolbox-item toolbox-show">
                          <label>Show:</label>
                          <div className="select-custom">
                            {showiconTwo ? (
                              <RiArrowDropUpLine className="arrow-custom-after" />
                            ) : (
                              <RiArrowDropDownLine className="arrow-custom-after" />
                            )}
                            <select
                              name="count"
                              className="form-control"
                              onClick={() => handleiconstwo()}
                              onChange={(e) => handleRecordCount(e)}
                              onBlur={(e) => handleiconblurecount(e)}
                            >
                              <option value="12">12</option>
                              {/* {filteredProducts.length > 12 && ( */}
                              {/* <> */}
                              <option value="24">24</option>
                              <option value="36">36</option>
                              {/* </> */}
                              {/* )} */}
                            </select>
                          </div>
                        </div>
                      )}
                      {/*                         
                            <div class="toolbox-item layout-modes">
                                <a href="category.html" class="layout-btn btn-grid active" title="Grid">
                                    <i class="icon-mode-grid"></i>
                                </a>
                                <a href="category-list.html" class="layout-btn btn-list" title="List">
                                    <i class="icon-mode-list"></i>
                                </a>
                            </div>  */}
                    </div>
                  </nav>

                  <div className="row" ref={rightContent}>
                    <Productlist
                      logointernational={internationalflag}
                      logoflag={germFreeflag}
                      products={filteredProducts}
                    />
                    <div className="container listing-custom">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            category.fs_custom_under_products
                          ),
                        }}
                      ></p>
                    </div>

                    {/* {categories.children_data.map((name) => (
                <>
                  {name.children_data.map((listname, j) => {
                    <>
                      <p
                        key={j}
                        dangerouslySetInnerHTML={{
                          __html: listname.fs_custom_under_products,
                        }}
                      />
                    </>;
                  })}
                </>
              ))} */}

                    {/* sortOptions={sortOptions} */}
                    {listing && (
                      <div className="flexend-pagination">
                        <nav className="toolbox toolbox-pagination">
                          {/* <div className='toolbox-item toolbox-show'>
                  <label>Show:</label>
                  <div className='select-custom'>
                    {showiconTwo ? (
                      <RiArrowDropUpLine className='arrow-custom-after' />
                    ) : (
                      <RiArrowDropDownLine className='arrow-custom-after' />
                    )}
                    <select
                      name='count'
                      onClick={() => handleiconstwo()}
                      onChange={(e) => handleRecordCount(e)}
                      className='form-control'
                    >
                      <option value='12'>12</option>
                      <option value='24'>24</option>
                      <option value='36'>36</option>
                    </select>
                  </div>
                </div> */}
                          <ul className="pagination toolbox-item">
                            <Pagination
                              pages={getPageDetails()}
                              currentPage={selectedPageIndex}
                              color="info"
                              onClick={(event) => getPageData(event)}
                            />
                          </ul>
                        </nav>
                      </div>
                    )}
                  </div>
                </div>
                <div className="sidebar-overlay"></div>
                <aside className="sidebar-shop col-lg-3 order-lg-first mobile-sidebar">
                  <section>
                    <div className="main-heading  text-left">
                      <h2>Filter</h2>
                    </div>
                  </section>
                  <Maindiv
                    data-sticky-options="{'mobile': false}"
                    ref={leftAboutMenu}
                    className="header-bottom sticky-header d-none d-md-flex"
                    style={getLeftFilterStyle()}
                  >
                    <ProductFilter
                      filter={filters}
                      filteroptions={fiterOption}
                      onChange={onFilterChange}
                      onRemove={onRemoveFilter}
                      onRemoveAll={onRemoveAll}
                    />
                  </Maindiv>
                </aside>
              </div>
              <div className="row">
                <div className="container custom-description-listing">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        category.fs_custom_description
                      ),
                    }}
                  ></p>
                </div>
              </div>
            </div>

            <div className="extraspace"></div>
          </section>
          {loader && (
            <div className="loading-overlay">
              <div className="bounce-loader">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
              </div>
            </div>
          )}
        </span>
      ) : (
        <span ref={controlContainer} className="page-wrapper">
          <div id={"view_first"} className="banner">
            <ErrorPage />
          </div>
        </span>
      )}
    </>
  );
};
const Placeholder = styled.div`
  height: 10px;
`;

export default ProductListing;
